import { TextAIOutreachInformation } from "./TextAIOutreachInformation";
import { VoiceAIOutreachInformation } from "@/components/VoiceAIOutreachInformation";

import { TextAIOutreachWithProxy, VoiceAIOutreachSlim } from "@/types";

export const AgenticStaffingStatus = ({
  textAIOutreachWithProxy,
  voiceAIOutreachSlim,
}: {
  textAIOutreachWithProxy: TextAIOutreachWithProxy | null;
  voiceAIOutreachSlim: VoiceAIOutreachSlim | null;
}) => {
  if (voiceAIOutreachSlim) {
    return (
      <VoiceAIOutreachInformation voiceAIOutreachSlim={voiceAIOutreachSlim} />
    );
  }
  if (textAIOutreachWithProxy) {
    return (
      <TextAIOutreachInformation
        textAIOutreachWithProxy={textAIOutreachWithProxy}
      />
    );
  }
  return <p className="font-medium text-slate-400">No agentic activity</p>;
};
